export default __webpack_public_path__ + "static/media/This is one of my unusual skills.aa14cb76.mp4";